import { createStore, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import user from './user';
import orders from './orders';
import products from './products';
import sidebarShow from './sidebarShow';

export default combineReducers({
	user,
	sidebarShow,
	orders,
	products,
	form: formReducer,
})